import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
	selector: 'show-hide-password',
	template: `
        <ba-checkbox
        	[label]="label"
        	(onCheckboxChange)="checkboxChanged($event)"
        >
        </ba-checkbox>
    	`,
	styles:[``],
})

export class ShowHidePasswordComponent {

	@Input() label:string;
	@Output() showHidePassword = new EventEmitter<any>();

	constructor( ) { }

	checkboxChanged(value){
		this.showHidePassword.emit(value);
	}
}




// WEBPACK FOOTER //
// /Users/Miroslav/Projects/Dubravica/backoffice/src/app/theme/components/showHidePassword/showHidePassword.component.ts